const loaded = [];
export const loadScript = (
  url: string,
  options: { ignoreErrors?: boolean; id?: string; attributes?: { [key: string]: string } } = {}
) => {
  return new Promise((resolve, reject) => {
    if (loaded.includes(url)) return resolve(true);
    const script = document.createElement('script');
    script.defer = true;
    script.async = true;
    if (options.id) script.id = options.id;
    if (options.attributes) {
      for (const i in options.attributes) script.setAttribute(i, options.attributes[i]);
    }
    script.onload = () => {
      loaded.push(url);
      resolve(true);
    };
    if (!options.ignoreErrors) script.onerror = err => reject(err);
    script.src = url;
    document.getElementsByTagName('head')[0]?.appendChild(script); // not there in iframe
  });
};
